import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Row, Col, Label, Input, FormFeedback, Table, Button, Alert } from 'reactstrap';

import ParadigmaModal from "../../../../components/ParadigmaModal/ParadigmaModal.js"
import ParadigmaLabeledInput from "../../../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"
import ParadigmaAsyncSeeker from "../../../../components/ParadigmaAsyncSeeker/ParadigmaAsyncSeeker.js"
import ParadigmaAsyncSeeker2 from "../../../../components/ParadigmaAsyncSeeker_v2/ParadigmaAsyncSeeker.js"
import CurrencyInput from "../../../../components/ParadigmaCurrencyInput/ParadigmaCurrencyInput.js"

import { formatCurrency } from '../../../../functions/functions';

import api from "../../../../api/api";


const querySelectGrupos = {
  "columns": ["pk", "nombre"],
  "table": {
    "pageSize": 99,
    "page": 0,
    "filtered": [],
    "sorted": [{ "id": "nombre", "desc": false }]
  }
}

class Costos extends Component {
  constructor(props) {
    super(props);
    this.state = {
      imputacion_id: null,
      personal_id: null,
      nombre: '',
      monto: '0,00',

      funcionamientoPLQ: 40,
      ejecutores: 0,
      porcentajes: [],

      // labelAux: '',
      // porcentajeAux: 0,

      subtotal: '0',

      detalle: [],

      grupo_id: null,
      // porcentaje: 0,
      importe: '0,00',
      tituloSeparaciones_id: null,
      tituloSeparaciones_nombre: '',

      disabled: false,
      errors: {},
    };
  }

  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    id: PropTypes.func.isRequired,
  }


  getData() {
    const {
      monto, detalle,
      funcionamientoPLQ, ejecutores, porcentajes,
      imputacion_id, personal_id, grupo_id,
      nombre,
      subtotal,
      porcentaje, errors,
      // porcentajeAux, labelAux
    } = this.state;
    const parsearAFloat = (m) => (parseFloat(m.replace(/[.]/g, '').replace(',', '.')));
    const redSubTotal = (accumulator, currentValue) => (accumulator + (parsearAFloat(monto) * currentValue.porcentaje / 100));

    let data = {
      funcionamientoPLQ: funcionamientoPLQ,
      ejecutores: 100 - funcionamientoPLQ - porcentajes.reduce((previousValue, currentItem) => (previousValue + currentItem.porcentaje), 0),
      porcentajes: porcentajes,
      // labelAux: labelAux,
      // porcentajeAux: labelAux != '' ? porcentajeAux : 0,
      subtotal: detalle.reduce(redSubTotal, 0),
      detalle: detalle.map((e, i) => ({
        id: e.id,
        nombre: e.nombre,
        tituloSeparaciones_id: e.tituloSeparaciones_id,
        grupo_id: e.grupo_id,
        porcentaje: e.porcentaje,
        monto: (parsearAFloat(monto) * (e.porcentaje / 100)),
      }))
    };

    return data;
  }

  setData = (data) => {
    if (data.allowed) {
      this.setState({
        imputacion_id: data.imputacion_id,
        personal_id: data.personal_id,
        nombre: data.nombre,
        monto: data.monto.toString().replace('.', ','),

        funcionamientoPLQ: data.funcionamientoPLQ > 0 ? data.funcionamientoPLQ : (this.props.porcentajeFPLQ > 0 ? this.props.porcentajeFPLQ : 40),
        ejecutores: data.ejecutores > 0 ? data.ejecutores : (this.props.ejecutores > 0 ? this.props.ejecutores : 0),
        porcentajes: data.porcentajes.length > 0 ? data.porcentajes : (this.props.porcentajes.length > 0 ? this.props.porcentajes : []),

        // labelAux: (data.funcionamientoPLQ > 0 && data.labelAux) ? data.labelAux : this.props.labelAux,
        // porcentajeAux: (data.funcionamientoPLQ > 0 && data.porcentajeAux) ? data.porcentajeAux : (this.props.labelAux ? this.props.porcentajeAux : 0),

        subtotal: data.subtotal.toString().replace('.', ','),

        detalle: data.detalleSeparaciones.length > 0 ? (data.detalleSeparaciones) : ([]),
        // separaciones: data.separaciones.map((e) => {let aux = e; aux.monto=aux.monto.toString().replace('.', ','); return (aux)}),

        disabled: (data.montoADistribuirSeparaciones && data.montoADistribuirSeparaciones.length > 0) ? true : false,
      })
    }
  }

  onValidation = () => {
    const {
      imputacion_id, personal_id, nombre, monto, funcionamientoPLQ, subtotal,
      detalle,
      grupo_id, porcentaje
    } = this.state;
    const redPorcentajes = (accumulator, currentValue) => (accumulator + currentValue.porcentaje);

    let validate = true;
    let errors = { detalle: null };

    if (detalle.reduce(redPorcentajes, 0) > 100) {
      validate = false;
      errors.porcentaje = 'El porcentaje debe ser menor o igual a 100'
    } else {
      errors.porcentaje = undefined;
    }

    detalle.forEach((e) => {
      if (e.grupo_id == null && errors.detalle == null) {
        errors.detalle = 'Asigne un grupo a todos los detalles'
        validate = false;
      } else if (e.porcentaje == 0 && errors.detalle == null) {
        errors.detalle = 'Asigne un porcentaje mayor a 0 a los detalles'
        validate = false;
      }
    })

    this.setState({
      errors: errors,
    })

    return validate;
  }


  resetState = () => {
    this.setState({
      imputacion_id: null,
      personal_id: null,
      nombre: '',
      monto: '0',
      subtotal: '0',

      funcionamientoPLQ: 40,
      ejecutores: 0,
      porcentajes: [],

      detalle: [],

      grupo_id: null,
      // porcentaje: 0,
      importe: '0,00',
      tituloSeparaciones_id: null,
      tituloSeparaciones_nombre: '',

      disabled: false,
      errors: {},
    })
  }

  AddToTable = () => {
    const { monto, grupo_id, tituloSeparaciones_id, tituloSeparaciones_nombre, porcentaje, importe, detalle } = this.state;
    const redPorcentajes = (accumulator, currentValue) => (accumulator + currentValue.porcentaje);
    const redSubTotal = (accumulator, currentValue) => (accumulator + (parsearAFloat(monto) * currentValue.porcentaje / 100));

    let detalleaux = this.state.detalle;
    let errors = {};

    const parsearAFloat = (m) => parseFloat(m.replace(/[.]/g, '').replace(',', '.'));
    const parsearAString = (m) => m.toString().replace('.', ',');
    let _porcentaje = ((parsearAFloat(importe) * 100) / parsearAFloat(monto))

    // if(grupo_id!=null && tituloSeparaciones_id!=null && porcentaje>0 && porcentaje<=(100-detalle.reduce(redPorcentajes, 0))){
    if (grupo_id != null && tituloSeparaciones_id != null && _porcentaje > 0 && (parsearAFloat(importe) <= (parsearAFloat(monto) - detalle.reduce(redSubTotal, 0)))) {
      detalleaux.push({ id: null, nombre: '', tituloSeparaciones_id, tituloSeparaciones_nombre, grupo_id, porcentaje: _porcentaje, monto: '0' });
      this.setState({
        detalle: detalleaux,
        grupo_id: null,
        tituloSeparaciones_id: null,
        tituloSeparaciones_nombre: '',
        // porcentaje: 0,
        importe: '0,00',
        errors: {}
      })
    } else {

      if (grupo_id == null) {
        errors.grupo_id = 'Seleccione un grupo'
      }
      if (_porcentaje == 0 || _porcentaje > (100 - detalle.reduce(redPorcentajes, 0))) {
        errors.porcentaje = 'Seleccione un importe valido'
      }
      if (tituloSeparaciones_id == null) {
        errors.tituloSeparaciones_id = 'Seleccione un titulo'
      }

      this.setState({ errors });
    }
  }

  removeRow = (row) => {
    let detalle = this.state.detalle;
    detalle.splice(row, 1);
    this.setState({
      detalle: detalle,
    });
  }
  
  
  render() {
    const {
      imputacion_id, personal_id, grupo_id, tituloSeparaciones_id,
      nombre, monto, importe, subtotal,
      detalle,
      funcionamientoPLQ, ejecutores, porcentajes,
      tituloSeparaciones_nombre, porcentaje,
      disabled, errors,
      // labelAux, porcentajeAux
    } = this.state;

    const parsearAFloat = (m) => parseFloat(m.replace(/[.]/g, '').replace(',', '.'));
    const parsearAString = (m) => m.toString().replace('.', ',');

    const redPorcentajes = (accumulator, currentValue) => (accumulator + currentValue.porcentaje);
    const redSubTotal = (accumulator, currentValue) => (accumulator + (parsearAFloat(monto) * currentValue.porcentaje / 100));

    const formatMiles = (valor) => {
      if (valor === null || valor === undefined || valor === "") return "";

      const numeric = typeof valor === 'string'
        ? parseFloat(valor.replace(/[.]/g, '').replace(',', '.'))
        : Number(valor);
      if (isNaN(numeric)) return "";

      return numeric.toLocaleString("es-AR", { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    };
    return (
      <ParadigmaModal
        getUrl={api.imputaciones.separacionImputaciones.edit}
        postUrl={api.imputaciones.separacionImputaciones.edit}
        onPreSubmit={() => this.getData()}
        onGotData={(data) => this.setData(data)}
        onClose={() => this.resetState()}
        onValidation={() => this.onValidation()}
        onSubmit={() => { return true }}
        buttonTitle="Asignar Costos"
        title="Asignar Costos"
        id={this.props.id}
        successMessage="El Detalle ha sido editado con éxito."
        missingIdMessage="Debe seleccionar una fila."
        buttonIcon="fa fa-usd fa-lg"
        saveButton={true}
        closeButton={true}

        className='ui-modal-dialog ui-modal-lg'
      >
        <div className="ui-form">
        <section className="ui-section-block">
          <h5 className="ui-section-label">Datos de la distribución</h5>
          <div className="ui-row-2">
            <div>
              <ParadigmaLabeledInput
                disabled={true}
                label="Nombre"
                labelColumns={4}
                fieldColumns={8}
                value={nombre}
              />
            </div>
            <div>
              <ParadigmaLabeledInput
                label="Líder Técnico"
                labelColumns={4}
                fieldColumns={8}
                inputComponent={
                  <ParadigmaAsyncSeeker2
                    disabled={true}
                    clearable={true}
                    url={api.usuarios.personal.select}
                    parameters={{
                        paginationEnabled: false,
                        sort: ['fullname']
                    }}
                    displayField="fullname"
                    onChange={(data) => this.setState({personal_id: data.personal_id})}
                    value={personal_id}
                  />
                }
              />
            </div>
          </div>
          <div className="ui-row-2">
            <div>
              <ParadigmaLabeledInput
                label="Importe"
                disabled={true}
                labelColumns={4}
                fieldColumns={8}
                value={formatMiles(monto)}
              />
            </div>
          </div>
        </section>

        {
          (!!!disabled) &&
          <section className="ui-section-block">
          <h5 className="ui-section-label">Agregar costo</h5>
          <div className="ui-row-action-4">
            <div>
              <Label>Costos</Label>
              <ParadigmaAsyncSeeker
                url={api.imputaciones.titulosSeparaciones.select}
                fieldName=""
                onChange={(data) => this.setState({ tituloSeparaciones_id: data ? data.pk : null, tituloSeparaciones_nombre: data ? data.nombre : '', errors: {} })}
                value={tituloSeparaciones_id}
              />
              <FormFeedback className={(errors.tituloSeparaciones_id != undefined ? "d-block" : "")}>{errors.tituloSeparaciones_id}</FormFeedback>
            </div>
            <div>
              <Label>Grupo</Label>
              <ParadigmaAsyncSeeker
                url={api.usuarios.subgrupos.list + '?data=' + JSON.stringify(querySelectGrupos)}
                fieldName=""
                onChange={(data) => this.setState({ grupo_id: data ? data.pk : null, errors: {} })}
                value={grupo_id}
              />
              <FormFeedback className={(errors.grupo_id != undefined ? "d-block" : "")}>{errors.grupo_id}</FormFeedback>
            </div>
            <div>
              <Label>Importe</Label>
              <CurrencyInput
                className='monto'
                maskOptions={{ includeThousandsSeparator: true, allowLeadingZeroes: true, }}
                value={importe}
                selectOnFocus={true}
                onBlurComplete={true}
                dobleSimboloDecimal={true}
                onChange={(e) => {
                  let importeFloat = parsearAFloat(e);
                  let importeMonto = parsearAFloat(monto);
                  this.setState({
                    importe: (importeFloat <= (importeMonto - detalle.reduce(redSubTotal, 0))) ? (e) : parsearAString(importeMonto - detalle.reduce(redSubTotal, 0)),
                    errors: {}
                  });
                }}
              />
              <FormFeedback className={(errors.porcentaje != undefined ? "d-block" : "")}>{errors.porcentaje}</FormFeedback>
            </div>
            <Button onClick={(e) => this.AddToTable()}><i className="fa fa-plus"></i></Button>
          </div>
          </section>
        }

        <section className="ui-section-block">
          <h5 className="ui-section-label">Detalle de costos</h5>
            <Table className="ui-table ui-cost-table table-sm">
              <thead>
                <tr>
                  <th width='5%'></th>
                  <th width='25%'>Costos</th>
                  <th width='30%'>Grupo</th>
                  <th width='20%'>Porcentaje</th>
                  <th width='20%'>Importe</th>
                </tr>
              </thead>
              <tbody>
                {
                  detalle.map((data, i) => (
                    <tr className="bg-light" key={`static${i}`}>
                      <td width='5%'> {disabled == true ? '' : <Button className="btn-round btn-small btn-danger mr-1" onClick={(e) => this.removeRow(i)}><i className="fa fa-times"></i></Button>}</td>
                      <td width='25%'>{data.tituloSeparaciones_nombre}</td>
                      <td width='30%'>
                        <ParadigmaAsyncSeeker
                          url={api.usuarios.subgrupos.select}
                          disabled={disabled}
                          clearable={false}
                          fieldName=""
                          onChange={(data) => {
                            let detalleAux = detalle;
                            const idx = i;
                            detalleAux[idx].grupo_id = (data) ? (data.pk) : (null);
                            this.setState({ detalle: detalleAux })
                          }}
                          value={data.grupo_id}
                        />
                      </td>
                      <td width='20%' className='text-right'>
                        {formatCurrency(data.porcentaje)}
                      </td>
                      <td width='20%' className='text-right'>
                        {formatCurrency(parsearAFloat(monto) * (data.porcentaje / 100))}
                      </td>
                    </tr>
                  ))
                }
              </tbody>
              <tfoot>
                <tr>
                  <th colSpan="3" className="ui-table-total text-right pr-4 font-weight-bold">Subtotal</th>
                  <th colSpan="1" className="ui-table-total text-right font-weight-bold">
                    {'% ' + formatCurrency(detalle.reduce(redPorcentajes, 0))}
                  </th>
                  <th colSpan="1" className="ui-table-total text-right font-weight-bold">
                    {'$ ' + formatCurrency(detalle.reduce(redSubTotal, 0))}
                  </th>
                </tr>
              </tfoot>
            </Table>
        </section>

        <section className="ui-section-block">
          <h5 className="ui-section-label">Resumen</h5>
          <div className="ui-summary-panel">
            <div className="ui-summary-row">
              <span>Importe a Distribuir</span>
                <CurrencyInput
                  disabled={true}
                  placeholder='0'
                  className='monto'
                  selectOnFocus={true}
                  maskOptions={{
                    includeThousandsSeparator: true,
                    allowLeadingZeroes: true,
                  }}
                  value={(parsearAFloat(monto) - detalle.reduce(redSubTotal, 0)).toString().replace('.', ',')}
                />
            </div>

            <div className="ui-summary-row">
              <span>Funcionamiento PLQ (%)</span>
                    <div className="ui-percent-money">
                        <Input
                          disabled={disabled}
                          className="text-right"
                          type="number"
                          onFocus={e => e.target.select()}
                          value={funcionamientoPLQ}
                          onChange={(e) => this.setState({ funcionamientoPLQ: (!e.target.value ? 0 : (parseFloat(e.target.value) > 100 ? (100) : parseFloat(e.target.value))) })}
                        />
                        <CurrencyInput
                          disabled={true}
                          placeholder='0'
                          className='monto'
                          selectOnFocus={true}
                          maskOptions={{
                            includeThousandsSeparator: true,
                            allowLeadingZeroes: true,
                          }}
                          value={((parsearAFloat(monto) - detalle.reduce(redSubTotal, 0)) * (funcionamientoPLQ / 100)).toString().replace('.', ',')}
                        />
                    </div>
            </div>

            <div className="ui-summary-row">
              <span>Ejecutores (%)</span>
                    <div className="ui-percent-money">
                        <Input
                          disabled={true}
                          type="number"
                          className="text-right"
                          onFocus={e => e.target.select()}
                          value={100 - funcionamientoPLQ - porcentajes.reduce((previousValue, currentItem) => (previousValue + currentItem.porcentaje), 0)}
                        />
                        <CurrencyInput
                          disabled={true}
                          placeholder='0'
                          className='monto'
                          selectOnFocus={true}
                          maskOptions={{
                            includeThousandsSeparator: true,
                            allowLeadingZeroes: true,
                          }}
                          value={((parsearAFloat(monto) - detalle.reduce(redSubTotal, 0)) * ((100 - funcionamientoPLQ - porcentajes.reduce((previousValue, currentItem) => (previousValue + currentItem.porcentaje), 0)) / 100)).toString().replace('.', ',')}
                        />
                    </div>
            </div>

            {
              porcentajes.map((p, index) => p.porcentaje > 0 && (
                <div className="ui-summary-row" key={`porcentaje-custom-${index}`}>
                    <span>{p.label + " (%)"}</span>
                        <div className="ui-percent-money">
                            <Input
                              className="text-right"
                              type="number"
                              disabled={true}
                              onFocus={e => e.target.select()}
                              value={p.porcentaje}
                              // onChange={(e) => this.setState({ porcentajeAux: (!e.target.value ? 0 : (parseFloat(e.target.value) > 100 ? (100) : parseFloat(e.target.value))) })}
                              onChange={(e) => {
                                const idx = index;
                                const value = (!e.target.value ? 0 : (parseFloat(e.target.value) > 100 ? (100) : parseFloat(e.target.value)));
                                this.setState(prevState => {
                                  const _porcentajes = [...prevState.porcentajes];
                                  _porcentajes[idx].porcentaje = value;
                                  return { ...prevState, porcentajes: _porcentajes };
                                });
                              }}
                            />
                            <CurrencyInput
                              disabled={true}
                              placeholder='0'
                              className='monto'
                              selectOnFocus={true}
                              maskOptions={{
                                includeThousandsSeparator: true,
                                allowLeadingZeroes: true,
                              }}
                              value={((parsearAFloat(monto) - detalle.reduce(redSubTotal, 0)) * (p.porcentaje / 100)).toString().replace('.', ',')}
                            />
                        </div>
                </div>
              ))
            }

          </div>
        </section>

        <div className="mt-2">
            {
              (errors.detalle != null) &&
              <Alert color='danger' className='text-center'>{errors.detalle}</Alert>
            }
        </div>
        </div>

      </ParadigmaModal>
    );
  }
}

export default Costos;



// WEBPACK FOOTER //
// ./src/views/Imputaciones/Imputaciones/ImputarModal/Costos.js